module.exports = __webpack_public_path__ + "static/media/icon_jin5a11354e0ec8bc5e20924c5905823f2c.webp";